import ProviderEmailFilter from './ProviderEmailFilter.vue';
import RoleEmailFilter from './RoleEmailFilter.vue';
import SurveyEmailFilter from './SurveyEmailFilter.vue';

export default {
  provider: ProviderEmailFilter,
  role: RoleEmailFilter,
  survey: SurveyEmailFilter,
};
